import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { DeleteConfirmationDialog } from '@components/Forms';
import { ButtonColorProps } from 'types/common';

interface IDeleteDialogButtonProps {
	onDelete: () => void;
	buttonText: string;
	title: string;
	question: React.ReactNode;
	extraVerification: boolean;
	name?: string;
	inputHeader?: string;
	inputText?: string;
	disabled?: boolean;
	color?: ButtonColorProps;
}

const DeleteDialogButton = (props: IDeleteDialogButtonProps & ButtonProps) => {
	const {
		buttonText,
		onDelete,
		disabled,
		title,
		question,
		extraVerification,
		name,
		inputHeader,
		inputText,
		...rest
	} = props;

	const [open, setOpen] = React.useState(false);

	const handleClick = React.useCallback(() => setOpen(!open), [open, setOpen]);

	const handleDelete = React.useCallback(() => {
		onDelete();
		setOpen(!open);
	}, [open, setOpen, onDelete]);

	return (
		<>
			<Button
				variant="text"
				onClick={handleClick}
				data-testid="delete-dialog-button"
				disabled={disabled}
				{...rest}
			>
				{buttonText}
			</Button>
			{open && (
				<DeleteConfirmationDialog
					onDelete={handleDelete}
					onCancel={handleClick}
					title={title}
					question={question}
					extraVerification={extraVerification}
					name={name}
					inputHeader={inputHeader}
					inputText={inputText}
				/>
			)}
		</>
	);
};

DeleteDialogButton.defaultProps = {
	color: 'error',
	disabled: false,
	name: '',
	inputHeader: '',
	inputText: ''
};

export default DeleteDialogButton;
